import { EquipmentBlock } from "components/EquipmentBlock";
import { HeadingLevel } from "types/HeadingLevel";

export function ApplicationEquipment({
    applicationNumber,
    readOnly,
}: Readonly<{
    applicationNumber: string;
    readOnly: boolean;
}>) {
    return (
        <EquipmentBlock
            applicationNumber={applicationNumber}
            readOnly={readOnly}
            mobileActionsClassName="border-bottom"
            sectionHeadingLevel={HeadingLevel.H2}
        />
    );
}
